/* Unfurl — Korushop · Metanoia Studio */
(function () {
  var root = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  setTimeout(function () { if (!window.__ufAnimated) root.classList.remove('uf-js'); }, 3500);

  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-NZ', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var hdr = document.querySelector('.section-header');
    if (hdr) root.style.setProperty('--uf-sticky', (hdr.offsetHeight || 0) + 'px');

    var now = new Date();
    document.querySelectorAll('[data-uf-date="process"]').forEach(function (el) { el.textContent = 'by ' + fmt(addBiz(now, 2)); });
    document.querySelectorAll('[data-uf-date="arrive"]').forEach(function (el) { el.textContent = fmt(addBiz(now, 6)) + ' – ' + fmt(addBiz(now, 14)); });

    document.querySelectorAll('[data-uf-fit]').forEach(function (sec) {
      var cards = [].slice.call(sec.querySelectorAll('.uf-pc'));
      var chips = [].slice.call(sec.querySelectorAll('[data-f]'));
      var result = sec.querySelector('.uf-result');
      var allN = sec.querySelector('[data-f="all"] .n'); if (allN) allN.textContent = cards.length;
      function apply(f) {
        var n = 0;
        cards.forEach(function (c) { var ok = f === 'all' || (' ' + c.dataset.fits + ' ').indexOf(' ' + f + ' ') > -1; c.hidden = !ok; if (ok) n++; });
        chips.forEach(function (ch) { ch.setAttribute('aria-pressed', ch.dataset.f === f); });
        var chip = chips.filter(function (c) { return c.dataset.f === f; })[0];
        var label = chip ? chip.dataset.label : '';
        if (result) result.textContent = f === 'all' ? 'Showing ' + n + ' products' : n + ' products that fit ' + label;
      }
      sec.__ufRun = function (f) {
        if (document.startViewTransition && !reduce) { cards.forEach(function (c, i) { c.style.viewTransitionName = 'ufc' + sec.id.slice(-6) + i; }); document.startViewTransition(function () { apply(f); }); }
        else apply(f);
      };
      chips.forEach(function (ch) { ch.addEventListener('click', function () { sec.__ufRun(ch.dataset.f); }); });
    });
    document.querySelectorAll('[data-uf-jump]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = document.querySelector('[data-uf-fit]'); if (!sec) return;
        sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () { sec.__ufRun && sec.__ufRun(b.dataset.ufJump); }, 350);
      });
    });

    var toast = document.querySelector('.uf-toast');
    var tt;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-uf-add]'); if (!b) return;
      e.preventDefault(); b.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.dataset.ufAdd, quantity: 1 }], sections: 'cart-icon-bubble' })
      }).then(function (r) { return r.json(); }).then(function (data) {
        b.disabled = false;
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) { var tmp = document.createElement('div'); tmp.innerHTML = data.sections['cart-icon-bubble']; var inner = tmp.querySelector('.shopify-section'); bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML; }
        }
        if (toast) {
          toast.querySelector('[data-t]').innerHTML = data && data.status ? (data.description || 'Could not add this item') : '<b>Added</b> ' + (b.dataset.ufName || '') + ' <a href="' + (window.routes ? window.routes.cart_url : '/cart') + '">View cart</a>';
          toast.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, 3200);
        }
      }).catch(function () { b.disabled = false; window.location.href = b.closest('.uf-pc').querySelector('a').href; });
    });

    if (!window.gsap || reduce || root.classList.contains('shopify-design-mode')) { root.classList.remove('uf-js'); return; }
    window.__ufAnimated = true;
    var gsap = window.gsap; if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
    var seen = false; try { seen = !!sessionStorage.getItem('uf-seen'); sessionStorage.setItem('uf-seen', '1'); } catch (e) {}
    var k = seen ? 0.4 : 1, E = 'expo.out';

    if (document.querySelector('.uf-hero')) {
      var tl = gsap.timeline({ defaults: { ease: E } });
      tl.to('.uf-hero h1 .ln>span', { y: 0, duration: 1.1 * k, stagger: 0.09 * k })
        .from('[data-uf-hero]', { y: 20, opacity: 0, duration: 0.9 * k, stagger: 0.08 * k }, '<.25');
      document.querySelectorAll('.uf-stage .koru path').forEach(function (p) { var L = p.getTotalLength(); gsap.set(p, { strokeDasharray: L, strokeDashoffset: L }); tl.to(p, { strokeDashoffset: 0, duration: 1.8 * k, ease: 'power3.inOut' }, 0.1); });
      tl.from('.uf-orb', { scale: 0.6, opacity: 0, duration: 1 * k, stagger: 0.12 * k }, 0.5 * k);
      gsap.to('.uf-orb.o1', { y: -10, duration: 3, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 1.4 * k });
      gsap.to('.uf-orb.o3', { y: 8, duration: 2.6, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 1.4 * k });
    }
    if (!window.ScrollTrigger) { gsap.set('[data-uf-rv]', { opacity: 1, y: 0 }); return; }
    gsap.utils.toArray('[data-uf-rv]').forEach(function (el) { gsap.to(el, { opacity: 1, y: 0, duration: 0.9, ease: E, scrollTrigger: { trigger: el, start: 'top 88%', once: true } }); });
    ScrollTrigger.batch('.uf-grid .uf-pc', { start: 'top 92%', once: true, onEnter: function (b) { gsap.from(b, { y: 30, opacity: 0, duration: 0.8, stagger: 0.06, ease: E }); } });

    var bar = document.querySelector('.uf-stepsw .bar');
    if (bar) { var vert = matchMedia('(max-width:900px)').matches; gsap.fromTo(bar, vert ? { scaleY: 0 } : { scaleX: 0 }, Object.assign(vert ? { scaleY: 1 } : { scaleX: 1 }, { ease: 'none', scrollTrigger: { trigger: '.uf-stepsw', start: 'top 75%', end: 'bottom 55%', scrub: 0.6 } })); }

    var mm = gsap.matchMedia();
    document.querySelectorAll('.uf-worlds').forEach(function (sec) {
      mm.add('(min-width:900px)', function () {
        var track = sec.querySelector('.uf-track'); if (!track) return;
        track.style.overflow = 'visible'; track.style.scrollSnapType = 'none';
        var prog = sec.querySelector('.uf-wprog .fg path'), num = sec.querySelector('.uf-wprog [data-num]'), n = track.children.length;
        var L = prog ? prog.getTotalLength() : 0; if (prog) gsap.set(prog, { strokeDasharray: L, strokeDashoffset: L });
        var dist = function () { return track.scrollWidth - innerWidth; };
        var st = gsap.to(track, { x: function () { return -dist(); }, ease: 'none', scrollTrigger: { trigger: sec, start: 'top top', end: function () { return '+=' + dist(); }, pin: true, scrub: 0.6, invalidateOnRefresh: true,
          onUpdate: function (s) { if (prog) prog.style.strokeDashoffset = L * (1 - s.progress); if (num) num.textContent = String(Math.min(n, 1 + Math.floor(s.progress * n * 0.999))).padStart(2, '0') + ' / ' + String(n).padStart(2, '0'); } } });
        gsap.utils.toArray(sec.querySelectorAll('.uf-world .plate')).forEach(function (img) { gsap.fromTo(img, { rotate: -6, y: 30 }, { rotate: 4, y: -30, ease: 'none', scrollTrigger: { trigger: img.closest('.uf-world'), containerAnimation: st, start: 'left right', end: 'right left', scrub: true } }); });
        return function () { track.style.overflow = ''; track.style.scrollSnapType = ''; };
      });
    });

    var ak = document.querySelector('.uf-about svg path');
    if (ak) { var AL = ak.getTotalLength(); gsap.fromTo(ak, { strokeDasharray: AL, strokeDashoffset: AL }, { strokeDashoffset: 0, ease: 'none', scrollTrigger: { trigger: '.uf-about', start: 'top 85%', end: 'center 50%', scrub: 0.8 } }); }
  });
})();
